import { render, staticRenderFns } from "./AvatarPicker.vue?vue&type=template&id=75aedb4a&scoped=true"
import script from "./AvatarPicker.vue?vue&type=script&lang=js"
export * from "./AvatarPicker.vue?vue&type=script&lang=js"
import style0 from "./AvatarPicker.vue?vue&type=style&index=0&id=75aedb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aedb4a",
  null
  
)

export default component.exports